<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Store Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" aria-label="Close filters">
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list lines="none" mode="ios" class="admin-filter-form-list">
    <ion-item mode="ios" class="admin-filter-form-field">
      <ion-select label="Feed type" label-placement="floating" [(ngModel)]="feedType" aria-label="Feed type">
        <ion-select-option value="all">All</ion-select-option>
        <ion-select-option value="Prop">Products</ion-select-option>
        <ion-select-option value="Location">Locations</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</ion-content>
<ion-footer mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-grid class="ion-no-padding">
      <ion-row class="admin-filter-actions">
        <ion-col size="6"><ion-button mode="ios" color="warning" expand="full" shape="round" (click)="apply()">Apply</ion-button></ion-col>
        <ion-col size="6"><ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clear()">Clear</ion-button></ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
